import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/home/Hero";
import { SelectedThree } from "@/components/home/SelectedThree";
import { ProductStory } from "@/components/home/ProductStory";
import { Occasion } from "@/components/home/Occasion";
import { Details, FinalCta } from "@/components/home/Details";

export default function Home() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 60);
    return () => clearTimeout(t);
  }, [hash]);
  return (
    <main data-testid="home-page">
      <Hero />
      <SelectedThree />
      <ProductStory />
      <Occasion />
      <Details />
      <FinalCta />
    </main>
  );
}
